import Icon from "../../../../components/HOC/Icon";
import Button1 from "../../../../components/form/Button1";
import BookPassengerForm from "./BookPassengerForm";
import CheckedBags from "../../../../components/flight/CheckedBags";
import ExpandWrapper from "../../../../components/DIsplay/ExpandWrapper";
import SeatSelection from "./SeatSelection";
import { def } from "../../../../config";
import { getTestLevel } from "../../../../utils/testLevel";

function PassengerTypeIcon({ type }) {
  if (type === "adult") {
    return <Icon icon="el:person" className="w-8 h-8" />;
  }
  if (type === "child") {
    return <Icon icon="vaadin:child" className="w-8 h-8" />;
  }
  if (type === "infant") {
    return <Icon icon="cil:child" className="w-8 h-8" />;
  }
  return null;
}

function getPassengerTypeLabel(type) {
  if (type === "adult") return " (Adult over 12 years)";
  if (type === "child") return " (Child 2 - 11 years)";
  if (type === "infant") return " (Infant 0 - 2 years)";
  return "";
}

function hasCheckedBagsOffer(bookingData) {
  return bookingData?.offer
    ?.at(-1)
    ?.pricingInformation?.price?.additionalServices?.find(
      (obj) => obj?.service === "CHECKED_BAGS" && obj?.price,
    );
}

export default function BookPassengerItem({
  index,
  type,
  isExpanded,
  totalPassenger,
  onExpandChange,
  passengerData,
  onPassengerChange,
  onContactChange,
  onFillTestPassenger,
  offer,
  bookingData,
  bags,
  onBagChange,
  onSeatChange,
  children,
}) {
  const showCheckedBags = hasCheckedBagsOffer(bookingData);

  return (
    <ExpandWrapper open={isExpanded}>
      {(value) => {
        const { open, setOpen } = value || {};
        const handleOpen = (id) => {
          const element = document.getElementById(id);
          if (element) {
            setTimeout(
              () => element?.scrollIntoView({ behavior: "instant" }),
              500,
            );
          }
          console.log(element);
          setOpen(!open);
          onExpandChange(
            [...Array(totalPassenger)].map((_, j) => j === index && !open),
          );
        };

        return (
          <div className="my-4 max-w-full" id={"pass" + index}>
            <div className="rounded-md border border-gray-300 light-bg flex flex-wrap gap-4 p-4 items-center">
              <PassengerTypeIcon type={type} />

              <div
                className="flex-1 flex flex-col justify-center items-start"
                onDoubleClick={() =>
                  getTestLevel(def.devStatus) < 2 &&
                  onFillTestPassenger?.(index)
                }
              >
                <span>
                  {index === 0 ? "Primary Passenger" : `Passenger ${index + 1}`}
                </span>
                <span className="inline-block">
                  {getPassengerTypeLabel(type)}
                </span>
              </div>

              <div>
                <Button1
                  variant="outlined"
                  onClick={() => handleOpen("pass" + index)}
                  className="!flex !gap-2 !font-bold"
                >
                  <span>{open ? "-" : "+"}</span> Add passenger details
                </Button1>
              </div>
            </div>

            {open ? (
              <div className="p-2 py-4 flex flex-col gap-6 max-w-full">
                <BookPassengerForm
                  data={passengerData}
                  type={type}
                  onChange={(newObj) => onPassengerChange(newObj, index)}
                  onContactChange={onContactChange}
                />

                {showCheckedBags ? (
                  <div className="flex flex-col gap-4 ">
                    <h5>Flight extras</h5>

                    <div className="flex gap-4 justify-between max-w-full w-[700px] overflow-auto snap-x">
                      {offer?.directions?.map((direction, directionIndex) => {
                        const bagData = {
                          departure: direction[0].departure,
                          arrival: direction?.at(-1)?.arrival,
                          baggage: direction[0]?.baggage,
                          direction,
                          index: directionIndex,
                          passenger: index,
                        };

                        return (
                          <div
                            key={directionIndex}
                            className="snap-mandatory snap-center pb-3"
                          >
                            <CheckedBags
                              offer={bookingData?.offer?.at(-1)}
                              hide={directionIndex !== 0 ? ["wantMore"] : null}
                              selected={bags[directionIndex]?.[0][index]}
                              data={bagData}
                              callback={(obj) =>
                                onBagChange({ ...obj, i: index }, [
                                  directionIndex,
                                  0,
                                ])
                              }
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : null}

                <div className="flex flex-col gap-4 ">
                  <div className="flex gap-4 justify-between">
                    <SeatSelection
                      callback={(obj, { i: seg, j }) =>
                        onSeatChange(obj, { i: index, j, seg })
                      }
                      offer={offer}
                      hide={["info"]}
                    />
                  </div>
                </div>

                {children}
              </div>
            ) : null}
          </div>
        );
      }}
    </ExpandWrapper>
  );
}
